import { PrivateInterceptor } from "../../Base/interceptors/PrivateInterceptor";




// ***********************BODEGAS*************************


// OBTENER TODOS LAS BODEGAS
export const getBodegas = async () => {
  const respuesta = await PrivateInterceptor(`Suministros/Bodega`, "GET");
  return respuesta;
};

// OBTENER TODOS LAS BODEGAS
export const getBodegasAct = async () => {
  const respuesta = await PrivateInterceptor(`Suministros/Bodega/BodegasAct`, "GET");
  return respuesta;
};

// MODIFICAR BODEGAS
export const modificarBodega = async (data) => {
  const respuesta = await PrivateInterceptor(`Suministros/Bodega/add`, "POST", data);
  return respuesta;
};

// AGREGAR BODEGA
export const addBodega = async (data) => {
  const respuesta = await PrivateInterceptor(`Suministros/Bodega/add`, "POST", data);
  return respuesta;
};


// ***********************ESTANTES*************************


// OBTENER TODOS LOS ESTANTES
export const getEstantes = async () => {
  const respuesta = await PrivateInterceptor(`Suministros/Estante`, "GET");
  return respuesta;
};

// OBTENER TODOS LAS BODEGAS
export const getEstantesAct = async () => {
  const respuesta = await PrivateInterceptor(`Suministros/Estante/EstantesAct`, "GET");
  return respuesta;
};

export const getEstantesBodega = async (IdBodega) => {
  const respuesta = PrivateInterceptor(`Suministros/Estante/EstanteEnBodega/${IdBodega}`, 'GET');
  return respuesta;
}

// MODIFICAR ESTANTE
export const modificarEstante = async (data) => {
  const respuesta = await PrivateInterceptor(`Suministros/Estante/add`, "POST", data);
  return respuesta;
};

// AGREGAR ESTANTE
export const addEstante = async (data) => {
  const respuesta = await PrivateInterceptor(`Suministros/Estante/add`, "POST", data);
  return respuesta;
};


// ***********************POSICIONES*************************


// OBTENER TODOS LAS POSICIONES
export const getPosicion = async () => {
  const respuesta = await PrivateInterceptor(`Suministros/Posiciones`, "GET");
  return respuesta;
};

export const getPosicionesAct = async () => {
  const respuesta = await PrivateInterceptor(`Suministros/Posiciones/PosicionesAct`, "GET");
  return respuesta;
};

// MODIFICAR POSICION
export const modificarPosicion = async (data) => {
  const respuesta = await PrivateInterceptor(`Suministros/Posiciones/add`, "POST", data);
  return respuesta;
};

// AGREGAR POSICION
export const addPosicion = async (data) => {
  const respuesta = await PrivateInterceptor(`Suministros/Posiciones/add`, "POST", data);
  return respuesta;
};



// ***********************BANDEJAS*************************
export const getBandeja = async () => {
  const respuesta = await PrivateInterceptor(`Suministros/Bandeja`, "GET");
  return respuesta;
};

export const getBandejasActivas = async () => {
  const respuesta = await PrivateInterceptor(`Suministros/Bandeja/BandejasAct`, "GET");
  return respuesta;
};

export const guardarBandeja = async (datos) => {
  const respuesta = await PrivateInterceptor("Suministros/Bandeja/AgregarBandeja", "POST",{datos});
  return respuesta;
};

export const editarBandeja = async (datos) => {
  const respuesta = await PrivateInterceptor("Suministros/Bandeja/EditarBandeja", "POST",{datos});
  return respuesta;
};